import React, { useState, useEffect } from "react";
import { Box, Fade } from "@mui/material";

import Banner10 from "../assets/banners/banner10.png";
import Banner9 from "../assets/banners/banner9.png";
import Banner11 from "../assets/banners/banner11.png";

const Banner = () => {

    const banners = [Banner10, Banner11, Banner9, Banner11];

    const [index, setIndex] = useState(0);
    const [fade, setFade] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setFade(false);

            setTimeout(() => {
                setIndex((prev) => (prev + 1) % banners.length);
                setFade(true);
            }, 600);
        }, 5000);

        return () => clearInterval(interval);
    }, [banners.length]);

    return (
        <Box
            sx={{
                width: "100%",
                height: { xs: "450px", md: "800px" },
                position: "relative",
                overflow: "hidden",
            }}
        >
            <Fade in={fade} timeout={600}>
                <Box
                    component="img"
                    src={banners[index]}
                    alt="banner"
                    sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        position: "absolute",
                        top: 0,
                        left: 0,
                    }}
                />
            </Fade>
        </Box>
    );
};

export default Banner;
